import Session from './session'
import {payPlatform, PayPlatformType} from './utils/platform'

const session: Session = new Session()

export interface IExports extends Session {
    payPlatform: PayPlatformType
}

const exports: IExports = session as IExports
exports.payPlatform = payPlatform

export default exports
